import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
interface FeatureRowProps {
  eyebrow: string;
  title: string;
  body: string;
  bullets?: string[];
  visual: React.ReactNode;
  flip?: boolean;
}
export const FeatureRow = ({
  eyebrow,
  title,
  body,
  bullets,
  visual,
  flip = false
}: FeatureRowProps) => {
  return <div className="py-12 lg:py-16" data-id="element-1374" data-mp="uk2dv32w3xk5">
      <div className={`flex flex-col gap-12 items-center ${flip ? 'lg:flex-row-reverse' : 'lg:flex-row'}`} data-id="element-1375" data-mp="19ajn38lrnrrl">
        <Reveal className="w-full lg:w-1/2" data-id="element-1376" data-mp="14ax2ge3lz98r">
          <p className="text-xs font-semibold uppercase tracking-wider text-zano-pink mb-3" data-id="element-1377" data-mp="14ece16y2q05f">
            {eyebrow}
          </p>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-1378" data-mp="1e9ml493bwxq2">
            {title}
          </h3>
          <p className="text-lg text-gray-600 mb-6" data-id="element-1379" data-mp="3k2ck6az11kd7">{body}</p>
          {bullets && <ul className="space-y-3" data-id="element-1380" data-mp="3g21132mbbs3u">
              {bullets.map((b, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-1381" data-mp="3nf8942tgn2gx" data-mpi={i}>
                  <CheckCircle2 size={18} className="text-zano-pink mt-0.5 shrink-0" data-id="element-1382" data-mp="3nd3v2s1ukn2x" />{' '}
                  {b}
                </li>)}
            </ul>}
        </Reveal>
        <Reveal delay={0.1} className="w-full lg:w-1/2" data-id="element-1383" data-mp="5zi9e1vidkc7">
          <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100 shadow-inner" data-id="element-1384" data-mp="axjsunwujlo7">
            {visual}
          </div>
        </Reveal>
      </div>
    </div>;
};